module.exports = __webpack_public_path__ + "static/img/nodata_ranking.3f3b53a2.png";